// eslint-disable-next-line prettier/prettier
import type { InjectionKey } from 'vue';
import {Configuration} from '@/types/configuration.d';

const configurationKey = Symbol('configurationKey') as InjectionKey<Configuration>;

export default configurationKey;
